<template>
  <div class="flex flex-col">
    <div class="custom-css-text-title">
      <h5>Any styling specified here will override the default styling.</h5>
      <div>
        Refer to the
        <a
          target="_blank"
          href="https://docs.recurly.com/recurly-engage/docs/styling-fine-tuning-css-selectors"
          >documentation</a
        >
        for additional information.
      </div>
    </div>
    <RfButtonNew type="ghost" size="small" class="self-end" @click="modalOpen = true">
      <RfOpenInNewIcon class="h-4 w-4" /> Open editor
    </RfButtonNew>
    <component
      :is="codeEditor.CodeEditor"
      v-model="cssValues"
      v-bind="codeEditor.props"
      :languages="codeEditor.languages('css')"
      fontSize="13px"
    ></component>
    <RfCodeEditorModal
      v-model="modalOpen"
      v-model:code="cssValues"
      language="css"
      title="Custom CSS"
    />
  </div>
</template>

<script setup>
import { useCodeEditor } from "@/utils/composables/useCodeEditor";
import RfCodeEditorModal from "@/components/modals/RfCodeEditorModal.vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfOpenInNewIcon from "@/components/icons/RfOpenInNewIcon.vue";
import { computed, ref } from "vue";

const props = defineProps(["actions"]);

const codeEditor = useCodeEditor();
const modalOpen = ref(false);

const cssValues = computed({
  get() {
    if (props.actions.rf_settings_custom_css && props.actions.rf_settings_custom_css.length > 0) {
      return props.actions.rf_settings_custom_css;
    }
    return "/* your css here */";
  },
  set(value) {
    props.actions.rf_settings_custom_css = value;
  },
});
</script>
